<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "UsersAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  